import PropTypes from 'prop-types';
import React from 'react';

export const RatchetBracketWrapper = ({ softOrder, Component, ...rest }) => {
  const details = {
    tacticName: 'RATCHET_BRACKET',
    category: 'Exit',
    type: 'Ratchet Bracket',
    domain: 'Profit/Loss',
  };
  const stop = softOrder.stop;
  const priceToBreak = softOrder.priceToBreak;

  return <Component details={details} stop={stop} priceToBreak={priceToBreak} {...rest} />;
};

RatchetBracketWrapper.propTypes = {
  Component: PropTypes.any,
  softOrder: PropTypes.shape({
    priceToBreak: PropTypes.any,
    stop: PropTypes.any
  })
};

